import React from 'react'

const Icon = ({ icon, visible = true, className, ...props }) => {

  if (Array.isArray(icon)) {
    const [collection, iconName] = icon

    return (
      <i className={`${collection} ${visible ? '' : 'hidden'} fa-${iconName} ${className}`} {...props} />
    )
  }

  return (
    <i className={`fa fa-${icon} ${visible ? '' : 'hidden'} ${className}`} {...props} />
  )
}

export default Icon
